export const SITE_URL = "https://industrixsolution.com";
export const BRAND = "Industrix Solution";
export const TAGLINE = "Powering the Future of Manufacturing.";
export const EMAIL = "info@chandrabhansingh.in";
export const WA_NUMBER = "917024315567";
export const WA_URL = `https://wa.me/${WA_NUMBER}`;
export const PHONES = [
  { label: "+91 7024315567", href: "tel:+917024315567" },
  { label: "+91 9755121478", href: "tel:+919755121478" },
];
export const ADDRESS = {
  line: "Office No. 69, Ratan Colony, New Jail Road, Huzur",
  city: "Bhopal",
  region: "Madhya Pradesh",
  postal: "462038",
  country: "India",
  full: "Office No. 69, Ratan Colony, New Jail Road, Huzur, Bhopal, Madhya Pradesh 462038, India",
};

export const waLink = (text) => `${WA_URL}?text=${encodeURIComponent(text)}`;
export const WA_DEFAULT = waLink("Hello Industrix Solution, I would like to discuss a digital project for my industrial business.");

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", menu: "services" },
  { label: "Industries", to: "/industries", menu: "industries" },
  { label: "Solutions", to: "/solutions" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: BRAND,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/brand/logo.png`,
  email: EMAIL,
  telephone: "+91-7024315567",
  slogan: TAGLINE,
  address: {
    "@type": "PostalAddress",
    streetAddress: ADDRESS.line,
    addressLocality: ADDRESS.city,
    addressRegion: ADDRESS.region,
    postalCode: ADDRESS.postal,
    addressCountry: "IN",
  },
  contactPoint: [
    { "@type": "ContactPoint", telephone: "+91-7024315567", contactType: "sales", email: EMAIL, availableLanguage: ["English", "Hindi"] },
    { "@type": "ContactPoint", telephone: "+91-9755121478", contactType: "customer support" },
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: BRAND,
  url: `${SITE_URL}/`,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en",
};
